/* eslint-disable camelcase */
import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  members: {},
  member_ids: [],
  total: null,
  page: 1,
  fetching_topic_members: false,
  has_more_members: true,
  firstMembersFetch: true,
});

// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  let currentUser;

  switch (action.type) {
    case ActionTypes.FOLLOWED_TOPIC:
      currentUser = AlumniConnect.currentUser;

      return state
        .mergeIn(['members'], fromJS({ [currentUser.id]: currentUser }))
        .update('member_ids', (member_ids) =>
          member_ids.unshift(currentUser.id),
        );

    case ActionTypes.UNFOLLOWED_TOPIC:
      currentUser = AlumniConnect.currentUser;

      return state
        .deleteIn(['members', currentUser.id])
        .update('member_ids', (member_ids) =>
          member_ids.delete(member_ids.indexOf(currentUser.id)),
        );

    case ActionTypes.FETCHING_TOPIC_MEMBERS:
      return state.set('fetching_topic_members', true);

    case ActionTypes.FETCHED_TOPIC_MEMBERS:
      return state
        .mergeIn(['members'], fromJS(action.payload.members.entities.members))
        .update('member_ids', (member_ids) =>
          member_ids.push(...action.payload.members.result),
        )
        .set('total', action.payload.total)
        .set('page', state.get('page') + 1)
        .set(
          'has_more_members',
          state.get('members').size + action.payload.members.result.length <
            action.payload.total,
        )
        .set('fetching_topic_members', false)
        .set('firstMembersFetch', false);

    case ActionTypes.RESETING_TOPIC_MEMBERS:
      return state
        .set('page', 1)
        .set('total', null)
        .set('has_more_members', true)
        .updateIn(['members'], (members) => members.clear())
        .updateIn(['member_ids'], (member_ids) => member_ids.clear());

    default:
      return state;
  }
};
